module.exports = __webpack_public_path__ + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-7.bbc5066c.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeConfirmationView/images/radiance/radiance-7.png
// module id = 2690
// module chunks = 11